"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sidebarSizeMd = exports.sidebarSizeSm = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const SidebarLeftDefault_1 = tslib_1.__importDefault(require("./SidebarLeftDefault"));
const SidebarLeftSavedFilters_1 = tslib_1.__importDefault(require("./SidebarLeftSavedFilters"));
exports.sidebarSizeSm = 240;
exports.sidebarSizeMd = 320;
const SidebarLeft = (props) => {
    // If kind is not provided return default for backwards compatibility
    if (!props?.kind)
        return react_1.default.createElement(SidebarLeftDefault_1.default, { ...props });
    switch (props.kind) {
        case "default":
            return react_1.default.createElement(SidebarLeftDefault_1.default, { ...props });
        case "savedFilters":
            return react_1.default.createElement(SidebarLeftSavedFilters_1.default, { ...props });
        default:
            return null;
    }
};
exports.default = SidebarLeft;
